import Proyecciones from "./Proyecciones";
export default Proyecciones;